import React from 'react';

import { Flex } from '@chakra-ui/react';
import { Avatar, AvatarImage } from '@mesh.ai/rabbit';
import { format } from 'date-fns';

import { Advice, Praise } from 'assets/assetsV1/iconComponents';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { TagColored } from 'uiToolkitV1/Tag';
import { TextParseComponent } from 'uiToolkitV1/TextParseComponent';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const PraiseIcon = <Praise fill="none" color="#44812F" />;
const AdviceIcon = <Advice fill="none" color="#B96400" />;

const PraiseAdvice = ({ value }) => {
  if (value === 'APPRECIATIVE') {
    return (
      // eslint-disable-next-line react/no-unstable-nested-components
      <TagColored StartIcon={() => PraiseIcon} ml="auto" color="green">
        Praise
      </TagColored>
    );
  }
  if (value === 'CONSTRUCTIVE') {
    return (
      // eslint-disable-next-line react/no-unstable-nested-components
      <TagColored StartIcon={() => AdviceIcon} ml="auto" color="yellow">
        Feedback
      </TagColored>
    );
  }
  return null;
};

const DescriptionText = ({ type, hideViewFullComment, ...props }) => {
  const { value } = props.data.requestDetails ?? props.data.comment ?? {};
  const { text, macros } = value ?? {};

  const isReceivedType = type === 'RECEIVED';

  if (isReceivedType && !hideViewFullComment) {
    return (
      <Flex flex="1" sx={{ maxHeight: '60px', width: '100%', marginTop: '8px' }}>
        <TextBodyMedium
          style={{
            overflow: 'hidden',
            display: '-webkit-box',
            webkitLineClamp: '3',
            webkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
            hyphens: 'auto',
          }}
        >
          <TextParseComponent isMultiLineTruncate text={text} macros={macros} />
        </TextBodyMedium>
      </Flex>
    );
  }
  return null;
};

export default DescriptionText;

export const EmployeeData = (params) => {
  const { date, employee, feedbackType } = params?.data ?? {};
  const { imageUrl } = employee ?? '';
  const { displayName } = employee?.value ?? {};
  const dateValue = date ? format(new Date(date?.value), 'PP') : date?.value;
  const { value: feedbackTypeValue } = feedbackType ?? {};

  return (
    <Flex flexDir="column" mt={2}>
      <Flex>
        <ListItemComp
          title={displayName}
          withoutBackground
          isBoldText={false}
          subTitle={dateValue}
          // eslint-disable-next-line react/no-unstable-nested-components
          LeftComponent={() => (
            <Avatar size="md">
              <AvatarImage src={imageUrl} alt="Avatar" />
            </Avatar>
          )}
        />
        <PraiseAdvice value={feedbackTypeValue} />
      </Flex>

      <DescriptionText type="RECEIVED" {...params} />
    </Flex>
  );
};
